// extracted by mini-css-extract-plugin
export default {"alertModalCon":"AlertModal_alertModalCon__goyFQ","textalert":"AlertModal_textalert__Z2dan"};